import { render, staticRenderFns } from "./MetricUpload.vue?vue&type=template&id=474c4d8f&scoped=true"
import script from "./MetricUpload.vue?vue&type=script&lang=js"
export * from "./MetricUpload.vue?vue&type=script&lang=js"
import style0 from "./MetricUpload.vue?vue&type=style&index=0&id=474c4d8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474c4d8f",
  null
  
)

export default component.exports